module.exports = __webpack_public_path__ + "img/小茴香.f9d45efc.jpg";